import { QueryClient } from '@tanstack/react-query';

/**
 * App-wide React Query client. Exported as a module singleton (not just handed to
 * <QueryClientProvider>) so non-React code — e.g. the SignalR notifications connection — can
 * invalidate queries. It MUST be the same instance passed to the provider in index.tsx.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
